const Config = {
  'orderInvoice.exchange.type': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '发票类型',
    c: {
      type: 'constant',
      value: 'type',
    },
    d: {
      type: 'variable',
      func: ({ index }) => index + 1 || 0,
    },
  },
  'orderInvoice.exchange.mode': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '发票抬头类型',
    c: {
      type: 'constant',
      value: 'mode',
    },
    d: {
      type: 'variable',
      func: ({ index }) => index + 1 || 0,
    },
  },
  'orderInvoice.exchange.header': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '显示发票名称列表',
    c: {
      type: 'constant',
      value: 'header',
    },
    d: {
      type: 'constant',
      value: 1,
    },
  },
  'orderInvoice.exchange.done': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '提交',
    c: {
      type: 'constant',
      value: 'done',
    },
    d: {
      type: 'constant',
      value: 1,
    },
  },
  // 发票title列表点击
  'orderInvoice.exchange.headerlist.click': {
    operation: ['TOUCH'],
    title: '发票抬头列表点击',
    c: {
      type: 'variable',
      func: ({ flow }) => {
        return flow === 'person' ? 'person_header' : 'company_header';
      },
    },
    d: {
      type: 'variable',
      func: ({ d }) => d,
    },
  },
  // 发票title列表添加
  'orderInvoice.exchange.headerlist.add': {
    operation: ['TOUCH', 'VISIBLE'],
    title: '发票抬头列表添加发票',
    c: {
      type: 'variable',
      func: ({ flow }) => {
        return flow === 'person' ? 'person_upsert' : 'company_upsert';
      },
    },
    d: {
      type: 'constant',
      value: 1,
    },
    iid: {
      type: 'variable',
      func: ({ url }) => {
        return `u=${encodeURIComponent(url)}`;
      },
    },
  },
  // 发票title列表编辑
  'orderInvoice.exchange.headerlist.edit': {
    operation: ['TOUCH'],
    title: '发票抬头列表编辑',
    c: {
      type: 'variable',
      func: ({ flow }) => {
        return flow === 'person' ? 'person_update' : 'company_update';
      },
    },
    d: {
      type: 'variable',
      func: ({ d }) => d,
    },
    iid: {
      type: 'variable',
      func: ({ url }) => {
        return `u=${encodeURIComponent(url)}`;
      },
    },
  },
  'orderInvoice.exchange.headerlist.visible': {
    operation: ['VISIBLE'],
    title: '发票title列表',
    // 发票
    getParse: {
      type: 'variable',
      func: function (item = {}, visibleData, args) {
        const { pageName, traceObj } = args;
        const result = [
          {
            type: 'invoice',
            item: item.item,
            isViewable: item.isViewable,
            key: item.key,
            index: item.index,
            page: pageName,
            b: pageName,
            c: traceObj.flow === 'person' ? 'person_header' : 'company_header',
            d: item.index + 1,
          },
          {
            type: 'invoice',
            item: item.item,
            isViewable: item.isViewable,
            key: item.key,
            index: item.index,
            page: pageName,
            b: pageName,
            c: traceObj.flow === 'person' ? 'person_update' : 'company_update',
            d: item.index + 1,
          },
        ];
        return result;
      },
    },
  },
};

export default Config;
